<template>
  <div>
    <div class="px-4 pb-12 mx-8 rounded-xl">
      <div class="mt-5" v-if="downloadUrl">
        <div class="flex flex-row items-center justify-center">
          <div v-if="deviceIsIphone" class="flex flex-col items-center">
            <img
              @click="handleAppleDownload"
              class="w-40"
              :src="walletBadges.apple"
            />
            <c-loading-spinner :color="'white'" v-if="loading" />
          </div>
          <div v-else @click="handleAndroidDownload">
            <img class="w-52" :src="walletBadges.google" />
          </div>
        </div>
      </div>
      <div v-else class="flex flex-col items-center mt-8">
        <c-loading-spinner :color="'white'" />
      </div>
    </div>
    <div
      v-if="downloadUrl && !deviceIsIphone"
      class="flex flex-col items-center"
    >
      <div class="text-secondary text-sm mt-2 mx-8 text-center">
        {{ $t("google-wallet-message") }}:
      </div>
      <img
        @click="handleWalletPassDownload"
        class="w-32 mt-3"
        src="../assets/wallet-passes.png"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api.js";
import CLoadingSpinner from "../../../core-ui/src/components/CLoadingSpinner.vue";
import { mapState, mapActions } from "pinia";
import { authStore } from "@/stores/auth";
import appleWallet from "../assets/apple-wallet.svg";
import appleWalletEs from "../assets/apple-wallet-es.svg";
import googleWallet from "../assets/google-wallet.svg";
import googleWalletEs from "../assets/google-wallet-es.svg";

export default {
  name: "DownloadButtons",
  data() {
    return {
      downloadUrl: null,
      loading: false,
    };
  },
  async mounted() {
    try {
      this.downloadUrl = (
        await api.get(
          `/pass/${this.passId}/customer/${this.customerId}/downloadAndroidPassUrl`
        )
      ).data.downloadUrl;
    } catch (e) {
      this.removeCustomerInfoFromOrganization(this.organization.id);
      this.$router.replace({ name: "customerHub" });
    }
  },
  computed: {
    ...mapState(authStore, [
      "passId",
      "currentCustomer",
      "serviceWorkerRegistration",
    ]),
    walletBadges() {
      return this.$i18n.locale.toLowerCase().split("-")[0] === "es"
        ? { apple: appleWalletEs, google: googleWalletEs }
        : { apple: appleWallet, google: googleWallet };
    },
    customerId() {
      return this.currentCustomer?.id;
    },
    applePassUrl() {
      return `${import.meta.env.VITE_API_BASE_URL}/pass/${
        this.passId
      }/customer/${this.customerId}/downloadApplePass`;
    },
    deviceIsIphone() {
      return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
        "MacIntel",
      ].includes(navigator.platform);
    },
  },
  methods: {
    ...mapActions(authStore, ["removeCustomerInfoFromOrganization"]),
    async askForNotifications() {
      if (this.deviceIsIphone) return false;
      this.waitingNotificationsApproval = true;
      let result;
      try {
        result = await Promise.race([
          Notification.requestPermission(),
          new Promise((resolve) => setTimeout(() => resolve("denied"), 5000)),
        ]);
      } catch (e) {
        console.error(e);
      }
      this.waitingNotificationsApproval = false;
      return result === "granted";
    },
    async handleAndroidDownload() {
      await this.handlePushSubscription();
      await api.put(`/customer/${this.customerId}/trackAndroidDownload`);
      window.open(this.downloadUrl, "_blank");
    },
    async handlePushSubscription() {
      if (!(await this.askForNotifications())) return;
      let pushSubscription =
        await this.serviceWorkerRegistration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: import.meta.env
            .VITE_APPLICATION_SERVER_KEY_PUBLIC,
        });
      await api.post(`/customer/${this.customerId}/savePushSubscription`, {
        pushSubscription,
      });
    },
    handleAppleDownload() {
      const isFirefox = navigator.userAgent.toLowerCase().includes("fxios");
      if (isFirefox) {
        window.open(this.applePassUrl, "_blank");
        return;
      } else {
        this.loading = true;
        var req = new XMLHttpRequest();
        req.open("GET", this.applePassUrl, true);
        req.responseType = "blob";
        let that = this;
        req.onload = function () {
          var blob = req.response;
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.click();
          that.loading = false;
        };
        req.send();
      }
    },
    handleWalletPassDownload() {
      window.open(
        `https://walletpass.io?u=${encodeURIComponent(this.applePassUrl)}`,
        "_blank"
      );
    },
  },
  components: {
    CLoadingSpinner,
  },
};
</script>

<style></style>
